import { capitalize, dayjs } from '@tunasong/models'
import { getPlugin, usePlugins } from '@tunasong/plugin-lib'
import type { SidebarComponent } from '@tunasong/ui-lib'
import { Divider, ElementForm, HBox, Typography } from '@tunasong/ui-lib'
import type { FC } from 'react'

export const SidebarSettings: FC<SidebarComponent> = ({ entity, onEntityChange }) => {
  const plugins = usePlugins('all')
  const EntityProperties = entity ? getPlugin(entity, plugins)?.components?.Properties : null

  return (
    <div style={{ overflow: 'auto' }} key={entity.id}>
      <ElementForm element={entity} onChange={onEntityChange} />
      {EntityProperties ? (
        <>
          <Divider style={{ marginTop: 8, marginBottom: 8 }}>
            <Typography variant="caption">{capitalize(entity.type)} properties</Typography>
          </Divider>
          <EntityProperties key={entity.id} element={entity} onChange={onEntityChange} />
        </>
      ) : null}
      <Divider style={{ marginTop: 8, marginBottom: 8 }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
        <HBox style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="caption">Created</Typography>
          <Typography variant="caption"> {dayjs(entity.createdAt).format('LL')}</Typography>
        </HBox>
        <HBox style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="caption">Last updated</Typography>
          <Typography variant="caption">{dayjs(entity.updatedAt).format('LL')}</Typography>
        </HBox>
      </div>
    </div>
  )
}
